import { z } from 'zod';

export const OTPRegisterValidator = z
  .object({
    email: z
      .string()
      .email({
        message: 'Please enter a valid email address.',
      })
      .min(1, {
        message: 'Please enter email.',
      }),
    password: z.string().min(1, {
      message: 'Please enter password.',
    }),
    confirmPassword: z.string().min(1, {
      message: 'Please enter confirm password.',
    }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    path: ['confirmPassword'],
    message: 'Passwords does not match',
  });

export type OTPRegisterFormData = z.infer<typeof OTPRegisterValidator>;
